/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NonCadastralParcelSearchResponseDto } from './nonCadastralParcelSearchResponseDto.model';


export interface ListResponseNonCadastralParcelSearchResponseDto { 
    itemCount?: number;
    items?: Array<NonCadastralParcelSearchResponseDto>;
    params?: { [key: string]: any; };
}

